const dap = state => state;
export default {
    dap
};
